import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider.jsx';
import './i18n';

import './scss/app.scss'; // 引入 Bootstrap 的 CSS 文件

createRoot(document.getElementById('root')).render(
	<BrowserRouter basename={import.meta.env.VITE_APP_BASENAME}>
		{/* <StrictMode> */}
		<AuthProvider>
			<App />
		</AuthProvider>
		{/* </StrictMode> */}
	</BrowserRouter>
);
